<template>
    <div class="row justify-content-center">
        <template v-if="!isSuccess">
            <div class="login-wrap">
                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-md-12">
                            <h3>Please enter your username and we will send a password reset link to your email.</h3>
                            <input type="text" class="form-control" placeholder="Username" v-model="model.username" required>
                            <div class="error-message alert alert-danger" v-for="(error, key) in errors.username" :key="key">{{ error }}</div>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-md-12">
                            <h3>Security Question</h3>
                            <select class="form-control" v-model="model.security_question" required>
                                <option value="">- Select security question -</option>
                                <option v-for="question in security_questions" :key="question.id" :value="question.id">{{ question.question }}</option>
                            </select>
                            <input type="text" class="form-control" placeholder="Your security answer" v-model="model.security_answer" required>
                            <div class="error-message alert alert-danger" v-for="(error, key) in errors.security_question" :key="key">{{ error }}</div>
                            <div class="error-message alert alert-danger" v-for="(error, key) in errors.security_answer" :key="key">{{ error }}</div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-12 text-center">
                            <button type="submit" class="btn btn-primary btn-block" :disabled="isSubmitting">
                                <span v-if="isSubmitting">Sending...</span>
                                <span v-else>Send Password Reset Link</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </template>
        <template v-else>
            <div class="row mt-6">
                <div class="col-md-12">
                    <p class="px-4">
                        A password reset link was sent to <b>{{ email }}</b>.
                        If you didn't receive any email
                        <template v-if="isSubmitting"><b><span class="fa fa-spinner fa-pulse"></span></b></template>
                        <template v-else>
                            <a href="javascript:void(0);" @click="submit"><b>Click Here</b></a>
                        </template>
                        to try again.
                    </p>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isSubmitting: false,
            isSuccess: false,
            errors: [],
            email: '',
            security_questions: [],
            model: {
                username: '',
                security_question: '',
                security_answer: ''
            }
        }
    },
    mounted() {
        this.get_security_questions()
    },
    methods: {
        get_security_questions() {
            this.$http.get('/api/security_questions')
                .then(response => {
                    this.security_questions = response.data.data
                })
        },
        submit() {
            this.isSubmitting = true
            this.$http.post('/api/reset_password_token', this.model)
                .then((res) => {
                    this.isSubmitting = false
                    this.isSuccess = true
                    this.email = res.data.data.email
                })
                .catch((error) => {
                    this.isSubmitting = false
                    if(error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.form-control {
    border: 1px solid #102e6c;
    border-radius: 4px;
    font-size: 13px;
    height: 47px;
    padding: 5px 10px;
    margin-bottom: 0.5em;
}
.btn-primary {
    padding: 12px 30px;
    width: 100%;
}
.error-message{
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    padding: 10px 15px;
    margin-bottom: 8px;
    border: 1px solid transparent;
    border-radius: 4px;
}
</style>
